// src/components/visitors/aircraftHelpers.js

// Conversions d'unités
export const lbsToKg = lbs => lbs ? Math.round(lbs * 0.453592) : '';
export const kgToLbs = kg => kg ? Math.round(kg / 0.453592) : '';
export const galToL = gal => gal ? Math.round(gal * 3.78541) : '';
export const lToGal = l => l ? +(l / 3.78541).toFixed(1) : '';

export const faaDateToISO = (d) => {
  if (!d) return '';
  const m = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return m ? `${m[3]}-${m[1]}-${m[2]}` : d;
};

// Composants UI réutilisables
export const AcSection = ({ title, children }) => (
  <div>
    <h4 className="text-xs font-semibold text-blue-400 uppercase tracking-wider mb-3 border-b border-gray-700 pb-1">
      {title}
    </h4>
    {children}
  </div>
);

export const AcLabel = ({ children }) => (
  <label className="text-gray-400 text-xs mb-1 block">{children}</label>
);

// Constantes
export const EMPTY_AIRCRAFT_FORM = {
  owner_id: '', tail_number: '', aircraft_type: '', manufacturer: '', model: '',
  year: '', year_manufactured: '', serial_number: '', callsign: '', icao_code: '',
  engine_type: '', engine_manufacturer: '', engine_model: '', engine_count: '',
  seats: '', fuel_type: 'JetA', fuel_capacity_gallons: '', max_fuel_gallons: '',
  max_takeoff_weight_lbs: '', max_landing_weight_lbs: '',
  home_base: '', parking_spot: '',
  owner_name: '', owner_address: '', owner_city: '', owner_state: '',
  owner_zip: '', owner_country: 'USA', owner_phone: '', owner_email: '',
  airworthiness_date: '', certificate_issue_date: '',
};

export const EMPTY_NEW_OWNER = { email: '', first_name: '', last_name: '', phone: '' };